import script from "./textareaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./textareaComponent.vue?vue&type=script&setup=true&lang=js"

import "./textareaComponent.vue?vue&type=style&index=0&id=f0c7c52a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0c7c52a"]])

export default __exports__